export default {
    buttons: {
        reset_password: 'Изменить пароль',
    },
    fields: {
        password: {
            label: 'Пароль',
            placeholder: 'Минимум 6 символов',
        },
        password_confirm: {
            label: 'Подтвердите пароль',
            placeholder: 'Введите пароль еще раз',
        },
    },
    errors: {
        passwords_not_match: 'Пароли не совпадают',
    },
}
